<template>
  <div class="row content-cession">
    <div class="col-lg-12">
      <div class="ibox">
        <div class="ibox-title">
          <h5><i class="fa fa-calendar"></i> Rendez-vous de cession</h5>
        </div>
        <div class="ibox-content">
          <div class="owner-wizard">
            <ul class="steps step-payment">
              <li v-for="(step, index) in steps"
                  :key="index"
                  :class="[index + 1 === activeStep ? 'active' : isAllowed(index + 1) ? 'allowed' : '']"
                  @click="toggleBlock(index + 1)">{{ index + 1 }}. {{ step }}</li>
            </ul>
            <h3 v-if="hasNoOwner || isSellerOwnerNotSet || hasCoOwnerNotSet || futureOwnerNotSet"
                style="margin-top: 20px; margin-left: 5px;">
              Pour accéder à cette section, merci de renseigner les informations du titulaire du véhicule.
            </h3>
            <template v-else-if="owner">
              <component
                 :is="component"
                 :seller="seller"
                 :owner="owner"
                 :command="command"
                 :initial-sale-rdv="initialSaleRdv"
                 v-on:update-initialSaleRdv-value="updateInitialSaleRdvValue"/>
            </template>
          </div>
        </div>
      </div>
      <button v-if="initialSaleRdv.id"
              type="button"
              class="btn btn-w-m btn-danger"
              @click="confirm('disposal')">Annuler ce mode de cession</button>
    </div>
  </div>
</template>

<script>
  import gql from 'graphql-tag'
  import Lieu from '../../components/details/cession/Lieu'
  import Participants from '../../components/details/cession/Participants'
  import Partenaire from '../../components/details/cession/Partenaire'
  import Confirmation from '../../components/details/cession/Confirmation'
  import Status from "@/components/details/Status.vue"

  export default {
    props: {
      command: {
        type: Object,
        required: true
      }
    },

    components: {
      'lieu': Lieu,
      'participants': Participants,
      'partenaire': Partenaire,
      'confirmation': Confirmation
    },

    data: () => ({
      blocks: [
        'lieu',
        'participants',
        'partenaire',
        'confirmation'
      ],
      steps: [
        'Lieu référence pour le RDV',
        'Participants et horaires',
        'Partenaire',
        'Création du RDV'
      ],
      activeStep: 1,
      ownerInformation: null,
      futureOwner: null,
    }),

    computed: {
      component () {
        return this.blocks[this.activeStep - 1]
      },

      seller () {
        return this.command.seller[0]
      },

      commandId () {
        return this.$route.params.id
      },

      initialSaleRdv: {
        get: function () {
          if (this.command.saleRdv && this.command.saleRdv[0]) {
            return this.command.saleRdv[0]
          }
          return {}
        },
        set: function (newValue) {

        }
      },

      isSellerOwnerNotSet () {
        return this.ownerInformation && this.ownerInformation.owners && typeof this.ownerInformation.owners.isSellerOwner !== typeof true
      },

      hasCoOwnerNotSet () {
        return this.ownerInformation && this.ownerInformation.owners && typeof this.ownerInformation.owners.hasCoOwner !== typeof true
      },

      futureOwnerNotSet () {
        return this.futureOwner && !this.futureOwner.owner;
      },

      ownerInformationQuery () {
        return gql`
        query{
          ownerInformation(orderId: "${this.commandId}") {
            owners {
              isSellerOwner
              hasCoOwner
              owner{
                firstName
                lastName
                address {
                  address
                  city
                  zipCode
                }
                civility
              }
            }
          }
        }`
      },

      futureOwnerInformationsQuery () {
        return gql`
        query{
          futureOwner(orderId:"${this.commandId}") {
            isBuyerOwner
            owner{
              firstName
              lastName
              documentId
              civility
              address {
                address
                city
                zipCode
              }
            }
          }
        }`
      },

      owner () {
        if (!this.ownerInformation || this.hasNoOwner) {
          return null
        }
        return this.ownerInformation.owners.owner
      },

      hasNoOwner () {
        return this.ownerInformation && !this.ownerInformation.owners
      },

      cancelDisposalMutation () {
        return gql`
          mutation {
            deleteSaleRdv(saleRdvId: ${this.command.saleRdv[0].id})
            {
              result
            }
          }`
      },
    },

    mounted () {
      if (!this.command.saleRdv) {
        this.command.saleRdv = [
          {}
        ]
      } else if (!this.command.saleRdv[0]) {
        this.command.saleRdv[0] = {}
      }
      if (this.initialSaleRdv.address && this.initialSaleRdv.address.address) {
        this.activeStep = 2
      }

      if (this.activeStep === 2 && this.initialSaleRdv.date) {
        this.activeStep = 3
      }

      if (this.activeStep === 3 && this.command.saleRdvExpert.name) {
        this.activeStep = 4
      }

      this.$bus.$on('disposal-confirm-success', this.onDisposalConfirm)
    },

    destroyed () {
      this.$bus.$off('disposal-confirm-success', this.onDisposalConfirm)
    },

    methods: {
      updateInitialSaleRdvValue (newValue) {
        this.initialSaleRdv = newValue
      },

      toggleBlock (step) {
        if (this.isAllowed(step)) {
          this.activeStep = step
        }
      },

      isAllowed (step) {
        if (step > 1 && (!this.initialSaleRdv.address || !this.initialSaleRdv.address.address)) {
          return false
        }
        if (step > 2 && !this.initialSaleRdv.date) {
          return false
        }
        if (step > 3 && !this.command.saleRdvExpert.name) {
          return false
        }

        return true
      },

      confirm (type) {
        let content = ''
        content = 'Souhaitez-vous annuler ce moyen de cession ?'
        this.showModal({
          childVue: 'confirm',
          dataModel: {
            title: 'Êtes-vous sûr ?',
            content,
            type
          }
        })
      },

      onDisposalConfirm () {

        if (this.command.saleRdv) {
          this.$apollo.mutate({
            mutation: this.cancelDisposalMutation
          }).then(() => {
            this.showBanner('success', `Succès: Le rendez-vous de cession a bien été supprimé`)
            this.command.saleRdv = null
            this.command.status.id = Status.constants.TO_PLANIFY
            this.$router.push(`/command/${this.commandId}`)
          })
        }
      },
    },

    apollo: {
      ownerInformation: {
        query () {
          return this.ownerInformationQuery
        }
      },
      futureOwner: {
        query () {
          return this.futureOwnerInformationsQuery
        }
      }
    }
  }
</script>
